import React, {FC, useEffect, useState} from 'react';

import {Modal} from '@optimaxdev/design-system';

import {Attention, Icon} from '@optimaxdev/icons';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {PaymentMethodsType} from 'types/PaymentMethodsType';

import {PAYMENTS} from '../../constants/paymentStep';

import {changePaymentMethod} from '../../store/reducers/paymentStep/paymentMethods/paymentMethods';
import {getCompleteOrderFirstErrorCode} from '../../store/selectors/completeOrder/completeOrder';

import {
    getNameSelectedMethod,
    getPaymentMethods,
} from '../../store/selectors/paymentStep/paymentStep';

import {BnPlOfferPopupList} from './bnplOfferPupupList/bnplOfferPopupList';

import {CREDIT_CART_METHODS, INSUFFICIENT_FUNDS} from './bnplOfferPupupList/constant';

import s from './bnplOfferPopup.scss';

type PropType = {
    changePayment: (code: PAYMENTS) => void;
    paymentMethods: PaymentMethodsType;
    completeOrderErrorCode: string;
    orderPaymentMethod: PAYMENTS;
};

/**
 * BnPlOfferPopup - offer a solution to users who don't have enough funds on their credit cards
 */
const BnPlOfferPopup: FC<PropType> = ({
    changePayment,
    completeOrderErrorCode,
    orderPaymentMethod,
    paymentMethods,
}) => {
    const [isClose, setIsClose] = useState(false);

    useEffect(() => {
        if (
            CREDIT_CART_METHODS.includes(orderPaymentMethod) &&
            completeOrderErrorCode === INSUFFICIENT_FUNDS
        ) {
            setIsClose(true);
        }
    }, [completeOrderErrorCode]);

    return (
        <Modal isOpen={isClose} onRequestClose={() => setIsClose(false)} overlay="dark">
            <div className={s.popupContent}>
                <div className={s.notificationContainer}>
                    <h2 className={s.notification}>
                        <Icon className={s.notificationIcon} icon={Attention} /> There was a problem
                        processing this card.
                    </h2>
                    <p className={s.notificationDescription}>
                        It looks like there aren&apos;t enough funds in your account. You can try
                        using a different method:
                    </p>
                </div>
                <BnPlOfferPopupList
                    changePayment={changePayment}
                    paymentMethods={paymentMethods}
                    setIsClose={setIsClose}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = (store: ApplicationStoreType) => ({
    completeOrderErrorCode: getCompleteOrderFirstErrorCode(store),
    orderPaymentMethod: getNameSelectedMethod(store),
    paymentMethods: getPaymentMethods(store),
});

const mapDispatchToProps = {
    changePayment: changePaymentMethod,
};

export const BnPlOfferPopupConnected = connect(mapStateToProps, mapDispatchToProps)(BnPlOfferPopup);
